<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Book Appointment" subtitle="Book Appointment"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing1 [data]="pricing"></app-pricing1> -->
        <!-- PRICING TABLE SECTION END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing2 [data]="pricing"></app-pricing2> -->
        <!-- PRICING TABLE SECTION END -->
     
        <div class="new-os-section" id="new-os-section">
          <div class="row">

              <div class="form-container">
                  <h4>Book Appointment</h4>
                  <p>Reach out and take the first step towards recovery.</p>
                  <br>
                  <br>
                  <form action="#" method="POST">
                    <div class="input-row">
                      <div style="
                      margin-right: 130px;
                  "> 
                  <span style="margin-right: 336px;">
                  <label>Name</label> </span>
                  <br>
                  <input type="text" name="name" placeholder="Name" required></div>
                      <div style="
                      margin-right: 130px;
                  ">
                   <span style="margin-right: 336px;"> <label>Email</label></span>
                 
                  <input type="email" name="email" placeholder="Email ID" required></div>
                      
                    </div>
                    
                    <div class="input-row">
                      <div style="
                      margin-right: 130px;
                  ">
                  <span style="margin-right: 336px;"> 
                  <label>Phone</label>
                  </span>
                  <input type="tel" name="phone" placeholder="Phone Number" required> </div>
                      <div style="
                      margin-right: 130px;
                  ">
                  <span style="margin-right: 324px;"> 
                   <label>Appointment Type</label>
                  </span>
                          <select name="appointment_type" required>
                              <option value="">Select Appointment Type</option>
                              <option value="consultation">Consultation</option>
                              <option value="therapy">Therapy</option>
                              <option value="follow_up">Follow-Up</option>
                            </select>
                      </div>
                      
                    </div>
                    <br>
                    <div class="btn-container">
                      <button type="submit">Request Call Back</button>
                    </div>
                  </form>
              </div>
          </div>
      
      </div>



    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>